import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

interface Props {
    color?: string;
    opacity?: string;
    fillOpacity?: string;
    size?: number;
    props?: React.ComponentProps<typeof SvgIcon>;
}

export const CustomSportsChess = ({
    color,
    opacity = '1',
    fillOpacity = '1',
    size = 20,
    props,
}: Props): JSX.Element => (
    <SvgIcon style={{ width: size, height: size }} {...props} viewBox={`0 0 ${size} ${size}`}>
        <path
            d={
                'M2.51367 18.7835V15.4502C2.51367 14.9919 2.67687 14.5995 3.00326 14.2731C3.32964 13.9467 3.72201 13.7835 4.18034 13.7835H5.26367L5.72201 10.4502H3.34701V8.78355H16.6803V10.4502H14.3053L14.7637 13.7835H15.847C16.3053 13.7835 16.6977 13.9467 17.0241 14.2731C17.3505 14.5995 17.5137 14.9919 17.5137 15.4502V18.7835H2.51367ZM5.38867 7.53355L4.18034 2.11688C4.63867 2.4641 5.11089 2.79049 5.59701 3.09605C6.08312 3.4016 6.61784 3.55438 7.20117 3.55438C7.75673 3.55438 8.26714 3.41202 8.73242 3.1273C9.1977 2.84258 9.62478 2.50577 10.0137 2.11688C10.4026 2.50577 10.8296 2.84258 11.2949 3.1273C11.7602 3.41202 12.2706 3.55438 12.8262 3.55438C13.4095 3.55438 13.9442 3.4016 14.4303 3.09605C14.9164 2.79049 15.3887 2.4641 15.847 2.11688L14.6595 7.53355H5.38867Z'
            }
            fill={color}
            opacity={opacity}
            fillOpacity={fillOpacity}
        />
    </SvgIcon>
);
